import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  // Service Home Page
  {
    path: '/maintenance/',
    name: 'Service',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance-group:read',
            'service_order:read',
          ])
        ) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    component: () => import('@/router/views/maintenance'),
  },

  {
    path: '/maintenance/serviceschedule',
    name: 'List Service Schedule',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance:create',
            'maintenance:update',
            'maintenance:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/serviceschedule'),
  },

  {
    path: '/maintenance/serviceschedule/import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance:create',
            'maintenance:update',
            'maintenance:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/serviceschedule/import'),
    children: [
      {
        path: '/maintenance/serviceschedule/import/upload',
        name: 'Service Schedule Import',
        component: () =>
          import('@/router/views/maintenance/serviceschedule/import/contents/Upload.vue'),
      },
      {
        path: '/maintenance/serviceschedule/import/process',
        name: 'Service Schedule Import Detail',
        component: () =>
          import('@/router/views/maintenance/serviceschedule/import/contents/Process.vue'),
      },
      {
        path: '/maintenance/serviceschedule/import/result',
        name: 'Service Schedule Import Result',
        component: () =>
          import('@/router/views/maintenance/serviceschedule/import/contents/Result.vue'),
      },
    ],
  },

  {
    path: '/maintenance/serviceschedule/detailserviceschedule/:vehicleId',
    name: 'Detail Service Schedule',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance:create',
            'maintenance:update',
            'maintenance:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/serviceschedule/detailserviceschedule'),
  },

  {
    path: '/maintenance/serviceschedule/add/:vehicleId?',
    name: 'Create Service Schedule',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance:create',
            'maintenance:update',
            'maintenance:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/serviceschedule/formserviceschedule'),
  },

  {
    path: '/maintenance/serviceschedule/formserviceschedule/:vehicleId?/:serviceId?/:serviceType',
    name: 'Form Service Schedule',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance:create',
            'maintenance:update',
            'maintenance:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/serviceschedule/formserviceschedule'),
  },

  {
    path: '/maintenance/servicealert',
    name: 'List Service Alert',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance:create',
            'maintenance:update',
            'maintenance:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/servicealert'),
  },

  {
    path: '/maintenance/servicealert/sendingemail',
    name: 'Email Service Alert',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance:create',
            'maintenance:update',
            'maintenance:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/servicealert/sendingemail'),
  },

  {
    path: '/maintenance/servicealert/historyemail',
    name: 'History Email Service Alert',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance:create',
            'maintenance:update',
            'maintenance:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/servicealert/historyemail'),
  },

  {
    path: '/maintenance/servicealert/emailcreate/:id?',
    name: 'Email Alert Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance:create',
            'maintenance:update',
            'maintenance:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/servicealert/CreateEmail'),
  },

  {
    path: '/maintenance/servicegroup/',
    name: 'Service Group',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance-group:read',
            'maintenance-group:create',
            'maintenance-group:update',
            'maintenance-group:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/servicegroup/'),
  },

  {
    path: '/maintenance/servicegroup/servicegroupdetail/conflict/:ssgroupId',
    name: 'Scheduled Conflict',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "master" */ '@/router/views/maintenance/servicegroup/detail/ConflictPage'
      ),
  },

  {
    path: '/maintenance/servicegroup/servicegroupdetail/:ssgroupId',
    name: 'Detail Group Service',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance-group:read',
            'maintenance-group:create',
            'maintenance-group:update',
            'maintenance-group:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/servicegroup/detail'),
  },

  {
    path: '/maintenance/servicegroup/servicegroupdetail/:ssgroupId/:duplicate',
    name: 'Duplicate Group Service',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance-group:read',
            'maintenance-group:create',
            'maintenance-group:update',
            'maintenance-group:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/servicegroup/detail'),
  },

  {
    path: '/maintenance/servicegroup/servicedetailcomponent/:ssgroupId',
    name: 'Add Component Schedule',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance-group:read',
            'maintenance-group:create',
            'maintenance-group:update',
            'maintenance-group:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/servicegroup/forms/ServiceDetailForm'),
  },

  {
    path: '/maintenance/servicegroup/servicedetailcomponent/:ssgroupId/:serviceId',
    name: 'Detail Component Schedule',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'maintenance:read',
            'maintenance-group:read',
            'maintenance-group:create',
            'maintenance-group:update',
            'maintenance-group:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Service' })
        }
      },
    },
    component: () => import('@/router/views/maintenance/servicegroup/forms/ServiceDetailForm'),
  },

  {
    path: '/maintenance/serviceschedule/detailserviceschedule/log/:vehicleId',
    name: 'Log Maintenance Detail Service Shceduler',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "setting" */ '@/router/views/maintenance/serviceschedule/detailserviceschedule/log'
      ),
  },

  {
    path: '/maintenance/serviceorder/form',
    name: 'Maintenance Create Service Order',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/maintenance/serviceorder/form'),
  },

  {
    path: '/maintenance/serviceorder/detail/:id',
    name: 'Maintenance Detail Service Order',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/maintenance/serviceorder/detail'),
  },

  {
    path: '/maintenance/serviceorder',
    name: 'Service Order List',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/maintenance/serviceorder'),
  },
]
